function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Component_138_1",
  "data-name": "Component 138 \\u2013 1",
  transform: "translate(0.5 0.5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_291",
  "data-name": "Path 291",
  d: "M352.766,141.718l10.275-8.828-12.3-14.942-11.083,7.515,13.1,16.256,10.275-8.828",
  transform: "translate(-329.271 -89.796)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_292",
  "data-name": "Path 292",
  d: "M409.365,91.9c-8.53,6.082-34.68,24.891-46.485,35.107l-9.94-12.075a15.057,15.057,0,0,0,2.1-2.049,7.394,7.394,0,0,0,1.525-6.61,16.423,16.423,0,0,0-3.192-6.049,33.4,33.4,0,0,0-5.411-5.48c-.271-.225-.611-.459-.969-.7a7.627,7.627,0,0,1-1.7-1.378c.6-1.36,2.719-1.176,4.68-.892l.07.01c2.769.4,5.158,2.517,6.908,4.06.275.248.547.487.818.726,3.11,2.775,5.8,5.167,10.229,6a35.3,35.3,0,0,0,12.728.152c6.137-1.185,13.06-4.239,20.579-9.086a10.787,10.787,0,0,1,6.532-2.017,6.648,6.648,0,0,1,1.525.28",
  transform: "translate(-329.936 -86.681)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_542",
  "data-name": "Path 542",
  d: "M424.01,87.758v.473a1.746,1.746,0,0,1-1.741,1.7H329.617a1.742,1.742,0,0,1-1.737-1.7v-.473a1.774,1.774,0,0,1,1.737-1.732h92.653a1.778,1.778,0,0,1,1.741,1.732",
  transform: "translate(-327.88 -86.026)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1
}));

function SvgBar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97.13,
    height: 53.138,
    viewBox: "0 0 97.13 53.138",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBar);
export default __webpack_public_path__ + "static/media/bar.8e0b9456bc6fea371ec5f1e8c0f540c4.svg";
export { ForwardRef as ReactComponent };